"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendForgotPasswordEmailRequestAction = exports.sendForgotPasswordEmailSuccessAction = exports.sendForgotPasswordEmailFailureAction = exports.sendForgotPasswordEmailValidationAction = exports.resetForgotPasswordStateAction = exports.setRecaptchaCodeAction = exports.setForgotPasswordEmailAction = void 0;
const ActionTypes = require("../../actionTypes/auth/forgotPassword");
const setForgotPasswordEmailAction = (email) => ({
    type: ActionTypes.SET_FORGOT_PASSWORD_EMAIL,
    payload: email
});
exports.setForgotPasswordEmailAction = setForgotPasswordEmailAction;
const setRecaptchaCodeAction = (code) => ({
    type: ActionTypes.SET_RECAPTCHA_CODE,
    payload: code
});
exports.setRecaptchaCodeAction = setRecaptchaCodeAction;
const resetForgotPasswordStateAction = () => {
    return {
        type: ActionTypes.RESET_FORGOT_PASSWORD_STATE
    };
};
exports.resetForgotPasswordStateAction = resetForgotPasswordStateAction;
const sendForgotPasswordEmailValidationAction = (error) => {
    return {
        type: ActionTypes.SEND_FORGOT_PASSWORD_EMAIL_VALIDATION,
        payload: error
    };
};
exports.sendForgotPasswordEmailValidationAction = sendForgotPasswordEmailValidationAction;
const sendForgotPasswordEmailFailureAction = (error) => {
    return {
        type: ActionTypes.SEND_FORGOT_PASSWORD_EMAIL_FAILURE,
        payload: error
    };
};
exports.sendForgotPasswordEmailFailureAction = sendForgotPasswordEmailFailureAction;
const sendForgotPasswordEmailSuccessAction = () => {
    return {
        type: ActionTypes.SEND_FORGOT_PASSWORD_EMAIL_SUCCESS
    };
};
exports.sendForgotPasswordEmailSuccessAction = sendForgotPasswordEmailSuccessAction;
const sendForgotPasswordEmailRequestAction = (email, code, language) => {
    return {
        type: ActionTypes.SEND_FORGOT_PASSWORD_EMAIL_REQUEST,
        payload: {
            email,
            code,
            language
        }
    };
};
exports.sendForgotPasswordEmailRequestAction = sendForgotPasswordEmailRequestAction;
//# sourceMappingURL=forgotPassword.js.map